import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as debug from 'debug';

@Component({
  selector: 'location-stop-car',
  templateUrl: 'location-stop-card.html',
})
export class LocationStopCardComponent {
  log = debug('app:LocationStopCardComponent');

  @Output()
  onClose = new EventEmitter<boolean>();
  @Input()
  feedBackMessage = null;
  @Input()
  cardType = 'weighStations';

  constructor() {
    this.log('Hello LocationStopCardComponent Component');
  }

  closeLocationStopCard() {
    this.onClose.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/components/location-stop-card/location-stop-card.ts